module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/campaign-one-ccf9ea4956b85575b9e930fb00c5bf3e.png";